(() => {
  const labelClass = 'product-meta__tax-label';
  const containerSelector = '.shopify-section--main-product .product-meta__price-list-container';

  const getPriceList = (container) => {
    return Array.from(container.children).find((child) => child.classList.contains('price-list'));
  };

  const getCurrentPrice = (priceList) => {
    return priceList.querySelector('.price--highlight') || priceList.querySelector('.price:not(.price--compare)');
  };

  const getTaxLabelTarget = (currentPrice) => {
    return currentPrice.querySelector('.money') || currentPrice;
  };

  const resetPriceList = (priceList) => {
    priceList.style.display = '';
    priceList.style.alignItems = '';
    priceList.style.flexWrap = '';
    priceList.style.columnGap = '';
    priceList.style.rowGap = '';
  };

  const styleLabel = (label, currentPrice) => {
    const priceStyle = window.getComputedStyle(currentPrice);

    label.style.color = priceStyle.color;
    label.style.display = 'inline-block';
    label.style.fontSize = '12px';
    label.style.fontWeight = '600';
    label.style.lineHeight = '1';
    label.style.marginInlineStart = '0.25em';
    label.style.marginInlineEnd = '0.45rem';
    label.style.whiteSpace = 'nowrap';
    label.style.verticalAlign = 'baseline';
  };

  const applyTaxLabels = () => {
    document.querySelectorAll(containerSelector).forEach((container) => {
      const priceList = getPriceList(container);

      if (!priceList) {
        return;
      }

      const currentPrice = getCurrentPrice(priceList);

      if (!currentPrice) {
        return;
      }

      const labelTarget = getTaxLabelTarget(currentPrice);

      resetPriceList(priceList);

      container.querySelectorAll(`.${labelClass}`).forEach((label) => {
        if (!labelTarget.contains(label)) {
          label.remove();
        }
      });

      const existingLabels = Array.from(labelTarget.querySelectorAll(`.${labelClass}`));
      let label = existingLabels.shift();

      existingLabels.forEach((extraLabel) => extraLabel.remove());

      if (!label) {
        label = document.createElement('span');
        label.className = `${labelClass} text--small`;
        label.textContent = '税込';
      }

      if (label.parentElement !== labelTarget || labelTarget.lastElementChild !== label) {
        labelTarget.appendChild(label);
      }

      styleLabel(label, currentPrice);
    });
  };

  const scheduleApplyTaxLabels = () => {
    window.requestAnimationFrame(applyTaxLabels);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyTaxLabels);
  } else {
    applyTaxLabels();
  }

  document.addEventListener('variant:changed', scheduleApplyTaxLabels);

  const observer = new MutationObserver((mutations) => {
    if (mutations.some((mutation) => mutation.type === 'childList')) {
      scheduleApplyTaxLabels();
    }
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();